import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"
import _imports_0 from '../../../assets/loader.min.svg'


const _hoisted_1 = { class: "flex items-center justify-end" }
const _hoisted_2 = { class: "flex flex-col space-y-4" }
const _hoisted_3 = { class: "w-full border-b border-b-darkgrey" }
const _hoisted_4 = { class: "relative items-center" }
const _hoisted_5 = { class: "whitespace-nowrap text-sm font-medium not-italic text-gray-800" }
const _hoisted_6 = { class: "flex flex-col" }
const _hoisted_7 = { class: "mb-4 flex w-full items-baseline justify-between border-b border-b-darkgrey" }
const _hoisted_8 = { class: "relative" }
const _hoisted_9 = {
  key: 0,
  class: "absolute inset-0 z-[2] flex h-full w-full items-center justify-center bg-[rgba(255,255,255,0.5)]"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_table_action_header = _resolveComponent("table-action-header")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_input_field = _resolveComponent("input-field")!
  const _component_json_editor_vue = _resolveComponent("json-editor-vue")!
  const _component_checkbox_input = _resolveComponent("checkbox-input")!
  const _component_vue_json_pretty = _resolveComponent("vue-json-pretty")!
  const _component_grid = _resolveComponent("grid")!
  const _component_main_section = _resolveComponent("main-section")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_main_section, null, {
      default: _withCtx(() => [
        _createVNode(_component_table_action_header, {
          title: "Commit dynamic asset action",
          description: " "
        }),
        _createElementVNode("form", {
          class: "space-y-4",
          onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_the_button, {
              "is-loading": _ctx.isSubmitLoading,
              "button-type": "primaryButton",
              text: "Commit"
            }, null, 8, ["is-loading"])
          ]),
          _createVNode(_component_grid, { "column-number": 2 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t("DeviceActions.RequestBody")), 1),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("DeviceActions.Device")), 1),
                  _createVNode(_component_v_select, {
                    modelValue: _ctx.formData.dataWrapper.deviceUuid,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.dataWrapper.deviceUuid) = $event)),
                    getOptionLabel: (assignment) => assignment.assignment.name,
                    options: _ctx.assignments,
                    reduce: (assignment) => assignment.device.deviceUuid,
                    class: "mt-1"
                  }, null, 8, ["modelValue", "getOptionLabel", "options", "reduce"])
                ]),
                _createVNode(_component_input_field, {
                  modelValue: _ctx.formData.dataWrapper.clientId,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.dataWrapper.clientId) = $event)),
                  label: _ctx.$t('DeviceActions.ClientId')
                }, null, 8, ["modelValue", "label"]),
                _createVNode(_component_json_editor_vue, {
                  modelValue: _ctx.formData.dataWrapper.data,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.dataWrapper.data) = $event)),
                  "main-menu-bar": false,
                  "status-bar": false,
                  mode: "text"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_input_field, {
                  modelValue: _ctx.formData.dataWrapper.requestTimeout,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.dataWrapper.requestTimeout) = $event)),
                  label: _ctx.$t('DeviceActions.RequestTimeout'),
                  "no-padding": true
                }, null, 8, ["modelValue", "label"]),
                _createVNode(_component_checkbox_input, {
                  modelValue: _ctx.formData.dataWrapper.storeCommit,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.dataWrapper.storeCommit) = $event)),
                  label: _ctx.$t('DeviceActions.StoreCommit')
                }, null, 8, ["modelValue", "label"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("h2", null, _toDisplayString(_ctx.$t("DeviceActions.ResponseBody")), 1),
                  _createVNode(_component_the_button, {
                    icon: ['fas', 'clipboard'],
                    size: "small",
                    type: "button",
                    variant: "ghost",
                    onExecuteMethod: _ctx.copyToClipboard
                  }, null, 8, ["onExecuteMethod"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  (_ctx.isSubmitLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[6] || (_cache[6] = [
                        _createElementVNode("img", {
                          alt: "Loading...",
                          src: _imports_0,
                          width: "100"
                        }, null, -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_vue_json_pretty, {
                    data: _ctx.response,
                    class: "scroll max-h-[56vh] overflow-y-auto"
                  }, null, 8, ["data"])
                ])
              ])
            ]),
            _: 1
          })
        ], 32)
      ]),
      _: 1
    })
  ]))
}